import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { forwardRef } from "react";
import { motion } from "framer-motion";
import { useGlobalData } from "@/contexts/GlobalData";
interface DynamicFontSizePropsType extends GeneralPropsType {
  fontSize: number;
  style?: any;
  disabledDynamicFontSize?: boolean;
}
export default motion(forwardRef<HTMLSpanElement, DynamicFontSizePropsType>(function DynamicFontSize({
  fontSize,
  children,
  onClick,
  className,
  style,
  disabledDynamicFontSize
}: DynamicFontSizePropsType, ref) {
  const scale = disabledDynamicFontSize ? 1 : 1.5;
  const {
    isLimitSize,
    screenSize
  } = useGlobalData();
  let fontSizeClass = "";
  if (fontSize || fontSize === 0) {
    if (!isLimitSize) {
      fontSizeClass = `clamp(${fontSize}px,${fontSize / 375 * 100}vw,${scale * fontSize}px)`;
    } else {
      fontSizeClass = `clamp(${fontSize}px,${fontSize / 375 * (screenSize?.realWidth / (screenSize?.width ?? 390) * 100)}vw,${scale * fontSize}px)`;
    }
  }
  return <span ref={ref} onClick={onClick} style={{
    fontSize: fontSizeClass,
    ...style
  }} className={clsx("inline-block whitespace-pre-wrap", styles.container, className)}>
                {children}
            </span>;
}));